import {
  REGISTRO_SUCCESS,
  REGISTRO_LOADING,
  REGISTRO_ERROR,
  REGISTRO_SETUSUARIO,
  REGISTRO_SETERRORUSUARIO,
} from "../../ActionTypes";

import axiosInstance from "../../../../global/helpers/axiosInstance";
import axiosLogin from "global/helpers/axiosLogin";
import {
  parseBackendError,
  logError,
} from "../../../../global/utils/errorHandler";

export const setUsuario = (usuario) => (dispatch) => {
  dispatch({
    type: REGISTRO_SETUSUARIO,
    payload: usuario,
  });
};

export const setListError = (listError) => (dispatch) => {
  dispatch({
    type: REGISTRO_SETERRORUSUARIO,
    payload: listError,
  });
};

export const registro = (usuario) => (dispatch) => {
  dispatch({
    type: REGISTRO_LOADING,
  });
  axiosLogin().then((respuesta) => {
    respuesta
      .post(`/shared/registro`, usuario)
      .then((res) => {
        dispatch({
          type: REGISTRO_SUCCESS,
          payload: res.data,
        });
      })
      .catch((err) => {
        // Parsear el error con nuestro handler robusto
        const parsedError = parseBackendError(err);

        // Log para debugging (solo en desarrollo)
        logError(err, "Registro de usuario");

        // Preparar payload de error normalizado
        // Mantiene retrocompatibilidad con 'detail' para código existente
        let error = {
          // RETROCOMPATIBILIDAD: detail siempre disponible
          detail: parsedError.userMessage,

          // Información adicional estructurada
          type: parsedError.type,
          validationErrors: parsedError.validationErrors,
          technicalDetails: parsedError.technicalDetails,
          title: parsedError.title,

          // Raw data por si necesitamos algo específico
          rawData: parsedError.rawData,
        };

        dispatch({
          type: REGISTRO_ERROR,
          payload: error,
        });
      });
  });
};
// export const registro = (usuario) => (dispatch) => {
//   dispatch({
//     type: REGISTRO_LOADING,
//   });
//   axiosInstance().then((respuesta) => {
//     respuesta
//       .post(`/registro`, usuario)
//       .then((res) => {
//         dispatch({
//           type: REGISTRO_SUCCESS,
//           payload: res.data,
//         });
//       })
//       .catch((err) => {
//         let error = {
//           detail: err.response
//             ? err.response.data
//             : "Error al contactar el server.",
//         };

//         dispatch({
//           type: REGISTRO_ERROR,
//           payload: error,
//         });
//       });
//   });
// };

export const resetErrorReg = () => (dispatch) => {
  dispatch({
    type: REGISTRO_ERROR,
    payload: null,
  });
};
